import { render, staticRenderFns } from "./RequestInfoDialog.vue?vue&type=template&id=789095b8&"
import script from "./RequestInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./RequestInfoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports